module.exports = __webpack_public_path__ + "img/2.9413c9a4.png";